import classNames from 'classnames';

import {
  FLYOUT_POSITION,
  SIDEMENU_Z_INDEX,
} from 'components/shared/side-menu/side-menu.constants';

interface FlyoutArrowProps {
  className?: string;
}

const FlyoutArrow = ({ className = 'h-6 mt-2' }: FlyoutArrowProps) => (
  <div className={classNames('w-2 overflow-hidden', className)}>
    <div className="w-3 h-3 bg-white border-l border-t border-navy-200 transform rotate-[-45deg] translate-x-1.5" />
  </div>
);

const FlyoutBridge = ({ top }: { top: number }) => (
  <div
    className="fixed h-10"
    style={{
      left: FLYOUT_POSITION.bridgeLeft,
      width: FLYOUT_POSITION.bridgeWidth,
      top,
      zIndex: SIDEMENU_Z_INDEX.flyoutBridge,
    }}
  />
);

interface FlyoutContainerProps {
  isVisible: boolean;
  top: number;
  isCollapsed?: boolean;
  alignItems?: string;
  containerRef?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
}

const FlyoutContainer = ({
  isVisible,
  top,
  isCollapsed = true,
  alignItems = 'items-start',
  containerRef,
  children,
}: FlyoutContainerProps) => {
  if (!isVisible) return null;

  const left = isCollapsed
    ? FLYOUT_POSITION.collapsedLeft
    : FLYOUT_POSITION.expandedLeft;

  return (
    <>
      <FlyoutBridge top={top} />
      <div
        ref={containerRef}
        className={classNames('fixed flex', alignItems)}
        style={{
          left,
          top,
          zIndex: SIDEMENU_Z_INDEX.flyout,
        }}
      >
        {children}
      </div>
    </>
  );
};

interface FlyoutPanelProps {
  children?: React.ReactNode;
  className?: string;
  arrowClassName?: string;
}

const FlyoutPanel = ({
  children,
  className = '',
  arrowClassName,
}: FlyoutPanelProps) => (
  <>
    <FlyoutArrow className={arrowClassName} />
    <div
      className={classNames(
        'bg-white rounded-xl border border-navy-200 -ml-px',
        className
      )}
    >
      {children}
    </div>
  </>
);

const FlyoutTooltip = ({ children }: { children?: React.ReactNode }) => (
  <>
    <FlyoutArrow className="h-4" />
    <div className="bg-white text-gray-900 text-base font-semibold px-4 py-2.5 rounded-xl border border-navy-200 whitespace-nowrap -ml-px">
      {children}
    </div>
  </>
);

export {
  FlyoutContainer,
  FlyoutPanel,
  FlyoutTooltip,
  FlyoutArrow,
  FlyoutBridge,
};
export default FlyoutContainer;
